module.exports = __webpack_public_path__ + "img/img-event-m-tab-02.9b858897.png";